import React, { useState ,useEffect} from 'react'
import { baseUrlback } from '../../../urlApi'
import Swal from 'sweetalert2'
import { useConsultarIp } from '../../../hooks/useConsultarIp'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import pencil from '../iconos/pencil.svg'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Loading } from '../../../components/Loading'





export const FirmarPdfRep = () => {

  let portal = localStorage.getItem('sid')

  const sid =  localStorage.getItem('sid')
  const strcon = localStorage.getItem('strcon')
  const codigo= localStorage.getItem('codigo')

  const empresa  = useSelector(state => state.app.empresa)

  const {ip} = useConsultarIp()
  let navigate = useNavigate();


  const {id} = useParams()


  const {state}  = useLocation()
  const { rut, nombre,email } = state;

  // console.log(rut,nombre,email)


  const [objPdf, setobjPdf] = useState( {
    firmas: 0,
    link: "https://www.websal.com/docs/001/hwn1vpy4/7lj07ks12hss/1546-202205-cnw7xkwhlh.pdf",
    base64:'',
    maxFirmas:2,
    firmantes:[]
})







        const consultarDatos = async () => {
          try {

              const response = await axios.get(`${baseUrlback}api/firma/byId/${id}`);
                      
              // console.log('CONSULTARDATOS',response.data)
                
              setobjPdf(response.data[0])

              return response.data[0]

              } catch (error) {
                
              alert("Error de conexion","Intentalo otra vez", );
                  
              }


        }


        

        useEffect(() => {

          consultarDatos()
        }, [])

      
 
    




    let nuevoFlujo = objPdf.maxFirmas === 2 && objPdf.firmas === 0 ? 'trabajador' : objPdf.maxFirmas === 2 && objPdf.firmas === 1 ? 'stopMail' : null

const [loading, setloading] = useState(false)


      const firmarAction = async () => {

      

        if(empresa.label == "Selecciona Empresa") {
             Swal.fire({
                icon: 'error',
                title: 'Selecciona empresa',
                confirmButtonColor:'#2ec1db',
                
              })
        }



        const resp = await consultarDatos()

        if(  resp.idContraparte === rut  && resp.firmaContraparte === true) return
        if(  resp.idContraparte2 === rut && resp.firmaContraparte2 === true) return

        let emails = {}

        if(objPdf.maxFirmas == 2){
           emails= {
            emailTrabajador: objPdf.emailTrabajador,
            emailContraparte: objPdf.emailContraparte
           }
        }
        if(objPdf.maxFirmas == 3){
           emails= {
            emailTrabajador: objPdf.emailTrabajador,
            emailContraparte: objPdf.emailContraparte,
            emailContraparte2: objPdf.emailContraparte2
           }
        }

        if(objPdf.maxFirmas == 1){
          emails= {
            emailTrabajador: objPdf.emailTrabajador
           }
        }

        // const mails = {}

        setloading(true)

        // consultarDatos()

        try {
          // console.log('hla')

          if(objPdf.maxFirmas === 2){
  

            if(objPdf.firmas === 0 && objPdf.flujo === 'simultaneo' ){
              // Si tiene 1 firma, puede que ambos esten viendo en simultaneo
                

                          const responseDoc = await axios.get(`${baseUrlback}api/firma/byId/${id}`);

                          const propDoc = responseDoc.data[0]
                          // const propDoc = responseDoc

                          // console.log('propDocpropDoc',propDoc)

                        const response = await axios.post(`${baseUrlback}api/firma/firmar`,
                            {
                              link:propDoc.link, firmas: propDoc.firmas, id:propDoc.id, rut:propDoc.idContraparte, nombre:propDoc.nombreContraparte, so:'pc', ip: ip ? ip : '-', tipo:propDoc.tipo, flujo:propDoc.flujo, nuevoFlujo, maxFirmas:propDoc.maxFirmas, persona:'contraparte', portal, empid:propDoc.empid, codper:propDoc.codper, emails,  empresa:empresa.label, nombreTrabajador:propDoc.nombreTrabajador, conid:propDoc.conid
                            },{
                              headers:{
                                'sid':sid,
                                'strcon':strcon,
                                'codigo':codigo
                              }
                            });

                              consultarDatos()
                
                              if(response.data.link ){
                                Swal.fire({
                                    title: 'Documento Firmado',
                                    confirmButtonColor:'#2ec1db',
                                    
                                  })
                                    setloading(false)
                                  
                              }else{ 
                                Swal.fire({
                                  icon: 'error',
                                  title: 'Error al firmar',
                                  confirmButtonColor:'#2ec1db',
                                  
                                })
                                  setloading(false)
                              }

            }else {
              
              // Si ya tiene 1 firma, es obvio que ya firmo el trabajador
            


                    const response = await axios.post(`${baseUrlback}api/firma/firmar`,
                    {
                      link:objPdf.link, firmas: objPdf.firmas, id:objPdf.id, rut:objPdf.idContraparte, nombre:objPdf.nombreContraparte, so:'pc', ip: ip ? ip : '-', tipo:objPdf.tipo, flujo:objPdf.flujo, nuevoFlujo, maxFirmas:objPdf.maxFirmas, persona:'contraparte', portal, empid:objPdf.empid, codper:objPdf.codper, emails,  empresa:empresa.label, nombreTrabajador:objPdf.nombreTrabajador, conid:objPdf.conid
                    },{
                      headers:{
                        'sid':sid,
                        'strcon':strcon,
                        'codigo':codigo
                      }
                    });


                      if(response.data.link ){
                        Swal.fire({
                            title: 'Documento Firmado',
                            confirmButtonColor:'#2ec1db',
                            
                          })
                            setloading(false)
                          
                      }else{

                        Swal.fire({
                          icon: 'error',
                          title: 'Error al firmar',
                          confirmButtonColor:'#2ec1db',
                          
                        })
                          setloading(false)

                      }

                      consultarDatos()


            }

          }
      

          if(objPdf.maxFirmas === 3){
            
              // Si tiene 3 firmas sin importar el flujo entra en opsitibilidad de simultaneo, puede que ambos esten viendo en simultaneo
                

                          const responseDoc = await axios.get(`${baseUrlback}api/firma/byId/${id}`);

                          const propDoc = responseDoc.data[0]
                          // const propDoc = responseDoc
                          let ncontraparte = ''


                          // Identificamos que firmante es
                          
                          if(propDoc.idContraparte == rut && propDoc.nombreContraparte == nombre){
                            ncontraparte = 1
                          }

                          if(propDoc.idContraparte2 == rut && propDoc.nombreContraparte2 == nombre){
                            ncontraparte = 2
                          }

                          // Nuevo flujo config

                          if(propDoc.flujo == 'contraparte' && propDoc.firmas == 0 ){
                            nuevoFlujo = 'contraparte'
                          }

                          if(propDoc.flujo == 'contraparte' && propDoc.firmas == 1 && propDoc.firmaTrabajador === false ){
                            nuevoFlujo = 'trabajador'
                          }
                          if(propDoc.flujo == 'contraparte' && propDoc.firmas == 1 && propDoc.firmaTrabajador === true ){
                            nuevoFlujo = 'contraparte'
                          }
                          if(propDoc.flujo == 'contraparte' && propDoc.firmas == 2 ){
                            nuevoFlujo = 'stopMail'
                          }
                          if(propDoc.flujo == 'simultaneo'  ){
                            nuevoFlujo = 'simultaneo'
                          }
                        
                          try {

                            const response = await axios.post(`${baseUrlback}api/firma/firmar3`,
                            {
                              firmaTrabajador:propDoc.firmaTrabajador,ncontraparte,link:propDoc.link, firmas: propDoc.firmas, id:propDoc.id, rut: ncontraparte == 2 ? propDoc.idContraparte2 : propDoc.idContraparte , nombre: ncontraparte == 2 ? propDoc.nombreContraparte2 : propDoc.nombreContraparte, so:'pc', ip: ip ? ip : '-', tipo:propDoc.tipo, flujo:propDoc.flujo, nuevoFlujo, maxFirmas:propDoc.maxFirmas, persona:'contraparte', portal, empid:propDoc.empid, codper:propDoc.codper, emails,  empresa:empresa.label, nombreTrabajador:propDoc.nombreTrabajador, conid:propDoc.conid
                            },{
                              headers:{
                                'sid':sid,
                                'strcon':strcon,
                                'codigo':codigo
                              }
                            });


                
                              if(response.data.link ){
                                Swal.fire({
                                    title: 'Documento Firmado',
                                    confirmButtonColor:'#2ec1db',
                                    
                                  })
                                    setloading(false)
                                  
                              }else{ 
                                Swal.fire({
                                  icon: 'error',
                                  title: 'Error al firmar',
                                  confirmButtonColor:'#2ec1db',
                                  
                                })
                                  setloading(false)
                              }

                            
                          } catch (error) {
                            console.log(error)
                          }
                         

                     
            


          }
           
              

   
   
           
   
         
           //  console.log(response.data)setRefresh
   
           
   
   
   
           } catch (error) {
             
            console.log(error)
              
                Swal.fire({
                  icon: 'error',
                  title: 'Error al firmar',
                  confirmButtonColor:'#2ec1db',
                  
                })
                  setloading(false)
               
           }



          consultarDatos()


      }



  return (

    <div className='contenedorPdf'>

    <div>     
                   {/* <div className='contenedorLogoFirma'>
                        <img  className='websalFirma animate__animated animate__fadeIn' src={websal} alt='ver' />

                   </div> */}



                    <div className='contenedorFirmas'>



                    <p className='ultimo tituloDocumento' >Documento: {objPdf.tipo} </p>



                  
                              <div className='documentos'>
                                        <p className='nombre' > {objPdf.nombreTrabajador} </p>
                                    

                                    <div className='contenedorPropiedadFirma' > 
                                        <p>RUT</p>
                                        <p> {objPdf.idTrabajador} </p>
                                            
                                    </div>

                                    <div className='contenedorPropiedadFirma' >

                                        <p>Fecha firma</p>
                                        <p>{objPdf.fechaTrabajador ? objPdf.fechaTrabajador : '-' } </p>

                                    </div>

                                    <div className='contenedorPropiedadFirma' >
                                    
                                        <p>IP</p>
                                        <p> {objPdf.ipTrabajador ? objPdf.ipTrabajador : '-' } </p>


                                    </div>

                                    <div className='contenedorPropiedadFirma last' >

                                        <p>Firmado desde</p>
                                        <p className='ultimo' > {objPdf.soTrabajador ? objPdf.soTrabajador.toUpperCase() : '-'} </p>

                                    </div>
                                    

                            </div>

                              <div className='documentos'>
                                        <p className='nombre' > {objPdf.nombreContraparte} </p>
                                    

                                    <div className='contenedorPropiedadFirma' > 
                                        <p>RUT</p>
                                        <p> {objPdf.idContraparte} </p>
                                            
                                    </div>

                                    <div className='contenedorPropiedadFirma' >

                                        <p>Fecha firma</p>
                                        <p>{objPdf.fechaContraparte ? objPdf.fechaContraparte : '-' } </p>

                                    </div>

                                    <div className='contenedorPropiedadFirma' >
                                    
                                        <p>IP</p>
                                        <p> {objPdf.ipContraparte ? objPdf.ipContraparte : '-' } </p>


                                    </div>

                                    <div className='contenedorPropiedadFirma last' >

                                        <p>Firmado desde</p>
                                        <p className='ultimo' > {objPdf.soContraparte ? objPdf.soContraparte.toUpperCase() : '-'} </p>

                                    </div>
                                    

                            </div>

                            { objPdf.maxFirmas === 3 &&
                            
                            <div className='documentos'>
                              
                                  <p className='nombre' > {objPdf.nombreContraparte2} </p>
                        

                                  <div className='contenedorPropiedadFirma' > 
                                      <p>RUT</p>
                                      <p> {objPdf.idContraparte2} </p>
                                          
                                  </div>

                                  <div className='contenedorPropiedadFirma' >

                                      <p>Fecha firma</p>
                                      <p>{objPdf.fechaContraparte2 ? objPdf.fechaContraparte2 : '-' } </p>

                                  </div>

                                  <div className='contenedorPropiedadFirma' >
                                  
                                      <p>IP</p>
                                      <p> {objPdf.ipContraparte2 ? objPdf.ipContraparte2 : '-' } </p>


                                  </div>

                                  <div className='contenedorPropiedadFirma last' >

                                      <p>Firmado desde</p>
                                      <p className='ultimo' > {objPdf.soContraparte2 ? objPdf.soContraparte2.toUpperCase() : '-'} </p>

                                  </div>
                                  

                          </div>
                            
                            
                            }

                             

                          

                    <p className='tituloDocumento'> Firmas: {objPdf.firmas} </p>
                               
                               {
                                loading && <Loading/>
                               }

                                {
                                rut == objPdf.idContraparte && objPdf.firmaContraparte === false && loading === false &&

                                <button onClick={firmarAction} className='firmarButton' >
                                Firmar

                                <img  className='firmarPencil animate__animated animate__fadeIn' src={pencil} alt='ver' />
                                </button>
                                }

                                {
                                rut == objPdf.idContraparte2 && objPdf.firmaContraparte2 === false && loading === false &&

                                <button onClick={firmarAction} className='firmarButton' >
                                Firmar

                                <img  className='firmarPencil animate__animated animate__fadeIn' src={pencil} alt='ver' />
                                </button>
                                }


                    </div>



        </div>

      


       <div className='pdf' >


        {
            objPdf.link &&

            <object
                                                
            data={`https://websalsign.s3.amazonaws.com/${objPdf.link}`}
            type="application/pdf" width="100%" height="100%"></object>
        }

    

            

               
       </div>



      
        
       
     </div>


  )
}
